<template>
  <div>
    <b-container>
      <b-row>
        <b-col class="pt-3 pb-2">
          <b-button
            variant="outline-primary"
            class="mr-2"
            :to="{ name: 'Home' }"
            ><b-icon-arrow-left
          /></b-button>
          <strong>{{ pageHeading }}</strong>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col cols="12">
          <si-search-input :value="query" />
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col cols="12">
          <span class="mr-1 text-muted"
            ><strong>{{ resultsCountToLocale }}</strong>
            {{ `result${resultsCount === 1 ? "" : "s"}` }} found
            <span v-show="query.length"
              >for &ldquo;{{ query }}&rdquo;</span
            ></span
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <si-post
            v-for="post in results"
            :key="post.id"
            :post="post"
            @destroy="onDelete($event)"
          />
        </b-col>
      </b-row>
    </b-container>
    <si-pagination
      :page="serpPage"
      :pages-count="serpCount"
      :route-name="routeName"
    />
  </div>
</template>

<script>
import PaginationNav from "@/components/message-board/PaginationNav";
import Post from "@/components/message-board/Post";
import SearchInput from "@/components/message-board/SearchInput";
import errorHandler from "@/services/errorHandler";
import debounce from "debounce";
import { confirmPostDelete } from "@/dialogs";
import postCategory from "@/services/postCategory";

export default {
  name: "Search",
  components: {
    "si-pagination": PaginationNav,
    "si-post": Post,
    "si-search-input": SearchInput,
  },
  data: () => ({
    fetchResults: null,
  }),
  computed: {
    category() {
      return postCategory.getBySlug(this.$route.params.category);
    },
    categoryId() {
      return this.category ? this.category.id : 0;
    },
    pageHeading() {
      if (this.serpUser.length) return `Search posts by ${this.serpUser}`;
      if (this.category) return `Search posts in ${this.category.name}`;
      return "Search";
    },
    query() {
      return this.$route.query.q || "";
    },
    results() {
      return this.$store.getters.results;
    },
    resultsCount() {
      return this.$store.getters.resultsCount;
    },
    resultsCountToLocale() {
      return Number(this.resultsCount).toLocaleString();
    },
    routeName() {
      return this.$route.name;
    },
    serpCount() {
      return this.$store.getters.serpCount;
    },
    serpPage() {
      let p = this.$route.query.p;
      if (p && +p > 0) {
        if (+p > +this.serpCount) {
          return +this.serpCount;
        }
        return +p;
      }
      return 1;
    },
    serpUser() {
      return this.$store.getters.serpUser;
    },
    user() {
      return this.$route.params.user || "";
    },
  },
  methods: {
    deletePost(id) {
      this.$store.dispatch("showBusy");
      this.$store
        .dispatch("deletePost", { id })
        .then(() => {
          this.fetchResults();
        })
        .catch((err) => {
          errorHandler(this, err);
          this.fetchResults();
        });
    },
    async onDelete(id) {
      let result = await confirmPostDelete(this);
      if (!result) return;
      this.deletePost(id);
    },
  },
  watch: {
    category() {
      this.fetchResults();
    },
    query() {
      this.fetchResults();
    },
    serpPage(value) {
      this.$store.dispatch("setSerpPage", value);
      this.fetchResults();
    },
    user() {
      this.fetchResults();
    },
  },
  created() {
    this.fetchResults = debounce(() => {
      this.$store.dispatch("showBusy");
      return this.$store
        .dispatch("fetchResults", {
          page: this.serpPage,
          query: this.query,
          category: this.categoryId,
          user: this.user,
        })
        .then(() => {
          this.$store.dispatch("hideBusy");
        })
        .catch(() => {
          this.$store.dispatch("clearResults");
          this.$store.dispatch("hideBusy");
        });
    }, 250);
  },
  mounted() {
    this.fetchResults();
  },
  beforeDestroy() {
    this.fetchResults.clear();
    this.$store.dispatch("clearResults");
    this.$store.dispatch("hideBusy");
  },
};
</script>
